<template>
  <table class="info info--importdata">
    <tbody>
      <tr
        v-for="(sub, subIndex) in list"
        :key="subIndex"
      >
        <td :style="{'width': '80%'}">
          {{ sub.name }}
        </td>
        <td
          :style="{'width': '20%'}"
          class="textRight"
        >
          <a
            href="#"
            @click.prevent="$emit('click', sub)"
            class="underline"
          >{{ label }}</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
    name: 'ImportSubstanceList',
    props: {
        list: { type: Array, required: true },
        label: { type: String, default: 'Opret' },
    },
};
</script>

<style lang="scss" scoped>
.textRight {
    text-align: right;
}
</style>
